var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    _vm._l(_vm.detailVos, function (item, k) {
      return _c(
        "div",
        { key: k, staticClass: "list-wrap" },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: item.indicatorName } },
                [
                  _c("el-input", {
                    attrs: { disabled: "", value: item.indicatorRate },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }